import SourceIQLogo from "../UILibrary/SourceIQLogo";
import { useNavigate } from "react-router-dom";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="bg-slate-900 text-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="flex flex-col space-y-6">
            <SourceIQLogo fill="white" width={153} height={26} />
            <p className="text-gray-300 text-left text-sm leading-relaxed max-w-sm mx-auto sm:max-w-2xl sm:mx-0">
              Transforming supplier management through AI-powered sourcing,
              automation, and intelligent marketplace connections.
            </p>
            <div className="flex flex-col space-y-3">
              <a
                href="mailto:info@sourceiq.com"
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM20 8L12.525 12.675C12.4417 12.725 12.3542 12.7625 12.2625 12.7875C12.1708 12.8125 12.0833 12.825 12 12.825C11.9167 12.825 11.8292 12.8125 11.7375 12.7875C11.6458 12.7625 11.5583 12.725 11.475 12.675L4 8V18H20V8ZM12 11L20 6H4L12 11ZM4 8.25V6.775V6.8V6.7875V8.25Z"
                    fill="white"
                  />
                </svg>
                <span className="text-sm">info@sourceiq.cloud</span>
              </a>
              {/* <a
                href="tel:+15551234567"
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M16.95 18C14.8667 18 12.8083 17.5458 10.775 16.6375C8.74167 15.7292 6.89167 14.4417 5.225 12.775C3.55833 11.1083 2.27083 9.25833 1.3625 7.225C0.454167 5.19167 0 3.13333 0 1.05C0 0.75 0.1 0.5 0.3 0.3C0.5 0.1 0.75 0 1.05 0H5.1C5.33333 0 5.54167 0.0791667 5.725 0.2375C5.90833 0.395833 6.01667 0.583333 6.05 0.8L6.7 4.3C6.73333 4.56667 6.725 4.79167 6.675 4.975C6.625 5.15833 6.53333 5.31667 6.4 5.45L3.975 7.9C4.30833 8.51667 4.70417 9.1125 5.1625 9.6875C5.62083 10.2625 6.125 10.8167 6.675 11.35C7.19167 11.8667 7.73333 12.3458 8.3 12.7875C8.86667 13.2292 9.46667 13.6333 10.1 14L12.45 11.65C12.6 11.5 12.7958 11.3875 13.0375 11.3125C13.2792 11.2375 13.5167 11.2167 13.75 11.25L17.2 11.95C17.4333 12.0167 17.625 12.1375 17.775 12.3125C17.925 12.4875 18 12.6833 18 12.9V16.95C18 17.25 17.9 17.5 17.7 17.7C17.5 17.9 17.25 18 16.95 18ZM3.025 6L4.675 4.35L4.25 2H2.025C2.10833 2.68333 2.225 3.35833 2.375 4.025C2.525 4.69167 2.74167 5.35 3.025 6ZM11.975 14.95C12.625 15.2333 13.2875 15.4583 13.9625 15.625C14.6375 15.7917 15.3167 15.9 16 15.95V13.75L13.65 13.275L11.975 14.95Z"
                    fill="white"
                  />
                </svg>
                <span className="text-sm">+1 (555) 123-4567</span>
              </a> */}
              {/* commented out location below */}
              {/* <div className="flex items-center space-x-3 text-gray-300">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C10.2333 22 8.79167 21.7208 7.675 21.1625C6.55833 20.6042 6 19.8833 6 19C6 18.6833 6.07083 18.3917 6.2125 18.125C6.35417 17.8583 6.56667 17.6083 6.85 17.375C7.08333 17.2083 7.3375 17.1417 7.6125 17.175C7.8875 17.2083 8.10833 17.3417 8.275 17.575C8.44167 17.8083 8.50417 18.0625 8.4625 18.3375C8.42083 18.6125 8.28333 18.8333 8.05 19C8.26667 19.2667 8.76667 19.5 9.55 19.7C10.3333 19.9 11.15 20 12 20C12.85 20 13.6667 19.9 14.45 19.7C15.2333 19.5 15.7333 19.2667 15.95 19C15.7167 18.8333 15.5792 18.6125 15.5375 18.3375C15.4958 18.0625 15.5583 17.8083 15.725 17.575C15.8917 17.3417 16.1125 17.2083 16.3875 17.175C16.6625 17.1417 16.9167 17.2083 17.15 17.375C17.4333 17.6083 17.6458 17.8583 17.7875 18.125C17.9292 18.3917 18 18.6833 18 19C18 19.8833 17.4417 20.6042 16.325 21.1625C15.2083 21.7208 13.7667 22 12 22ZM12.025 16.5C13.675 15.2833 14.9167 14.0625 15.75 12.8375C16.5833 11.6125 17 10.3833 17 9.15C17 7.45 16.4583 6.16667 15.375 5.3C14.2917 4.43333 13.1667 4 12 4C10.8333 4 9.70833 4.43333 8.625 5.3C7.54167 6.16667 7 7.45 7 9.15C7 10.2667 7.40833 11.4292 8.225 12.6375C9.04167 13.8458 10.3083 15.1333 12.025 16.5ZM12 18.525C11.8 18.525 11.6 18.4917 11.4 18.425C11.2 18.3583 11.0167 18.2583 10.85 18.125C8.88333 16.5583 7.41667 15.0292 6.45 13.5375C5.48333 12.0458 5 10.5833 5 9.15C5 7.96667 5.2125 6.92917 5.6375 6.0375C6.0625 5.14583 6.60833 4.4 7.275 3.8C7.94167 3.2 8.69167 2.75 9.525 2.45C10.3583 2.15 11.1833 2 12 2C12.8167 2 13.6417 2.15 14.475 2.45C15.3083 2.75 16.0583 3.2 16.725 3.8C17.3917 4.4 17.9375 5.14583 18.3625 6.0375C18.7875 6.92917 19 7.96667 19 9.15C19 10.5833 18.5167 12.0458 17.55 13.5375C16.5833 15.0292 15.1167 16.5583 13.15 18.125C12.9833 18.2583 12.8 18.3583 12.6 18.425C12.4 18.4917 12.2 18.525 12 18.525ZM12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11Z"
                    fill="white"
                  />
                </svg>
                <span className="text-sm">San Francisco, CA</span>
              </div> */}
            </div>
          </div>

          <div className="hidden md:block"></div>

          {/* <div className="flex justify-start items-start flex-col">
            <h3 className="text-white font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div> */}
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
            <div className="flex items-center space-x-4 mb-4 md:mb-0">
              <span className="text-gray-400 text-base">Reach us:</span>
              <a
                href="https://www.facebook.com/TalkDEI/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M14.2222 7.12798C14.2222 3.19088 11.0389 0 7.11111 0C3.18333 0 0 3.19088 0 7.12798C0 10.6864 2.6 13.635 6 14.1696V9.18841H4.19444V7.12798H6V5.55759C6 3.77142 7.06111 2.78437 8.68611 2.78437C9.46389 2.78437 10.2778 2.92358 10.2778 2.92358V4.67773H9.38056C8.49722 4.67773 8.22222 5.22765 8.22222 5.79148V7.12798H10.1944L9.87917 9.18841H8.22222V14.1696C11.6222 13.635 14.2222 10.6864 14.2222 7.12798Z"
                    fill="white"
                  />
                </svg>
              </a>
              <span className="hidden md:inline text-white mx-4">|</span>
              <a
                href="https://www.instagram.com/talkdei/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M7.11184 0C10.4948 0 13.2627 2.76787 13.2627 6.15083V7.11184C13.2627 10.4948 10.4948 13.2627 7.11184 13.2627H6.15083C2.76787 13.2627 0 10.4948 0 7.11184V6.15083C0 2.76787 2.76787 0 6.15083 0H7.11184ZM6.75224 3.33344L6.66667 3.33333C5.95407 3.33333 5.24147 3.35689 5.24147 3.35689C4.20065 3.35689 3.35689 4.20064 3.35689 5.24146C3.35689 5.24146 3.33526 5.85335 3.33345 6.51012L3.33333 6.596C3.33333 7.33136 3.35689 8.09187 3.35689 8.09187C3.35689 9.13269 4.20065 9.97645 5.24147 9.97645C5.24147 9.97645 5.90772 10 6.59601 10C7.33137 10 8.11543 9.97645 8.11543 9.97645C9.15626 9.97645 9.97645 9.15626 9.97645 8.11544C9.97645 8.11544 10 7.36349 10 6.64312L9.99957 6.47407C9.99638 5.82775 9.97643 5.2179 9.97643 5.2179C9.97643 4.17708 9.15624 3.35689 8.11542 3.35689C8.11542 3.35689 7.43698 3.33518 6.75224 3.33344ZM6.66667 3.93332C7.25101 3.93332 8.00023 3.95264 8.00023 3.95264C8.85371 3.95264 9.38068 4.4796 9.38068 5.33308C9.38068 5.33308 9.4 6.06951 9.4 6.64732C9.4 7.23802 9.38068 8.00021 9.38068 8.00021C9.38068 8.85369 8.85371 9.38065 8.00023 9.38065C8.00023 9.38065 7.33766 9.39689 6.76277 9.39959L6.60872 9.39997C6.04433 9.39997 5.35665 9.38065 5.35665 9.38065C4.50319 9.38065 3.95266 8.83011 3.95266 7.97666C3.95266 7.97666 3.93333 7.21169 3.93333 6.6087C3.93333 6.04431 3.95266 5.33308 3.95266 5.33308C3.95266 4.4796 4.5032 3.95264 5.35665 3.95264C5.35665 3.95264 6.08232 3.93332 6.66667 3.93332ZM6.66665 4.95913C5.72361 4.95913 4.95913 5.72361 4.95913 6.66664C4.95913 7.60968 5.72361 8.37416 6.66665 8.37416C7.60969 8.37416 8.37417 7.60968 8.37417 6.66664C8.37417 5.72361 7.60969 4.95913 6.66665 4.95913ZM6.66665 5.55553C7.28031 5.55553 7.77777 6.05299 7.77777 6.66664C7.77777 7.2803 7.28031 7.77776 6.66665 7.77776C6.05301 7.77776 5.55554 7.2803 5.55554 6.66664C5.55554 6.05299 6.053 5.55553 6.66665 5.55553ZM8.45587 4.48528C8.22802 4.48528 8.04329 4.67092 8.04329 4.89991C8.04329 5.12889 8.22802 5.31452 8.45587 5.31452C8.68373 5.31452 8.86844 5.12889 8.86844 4.89991C8.86844 4.67091 8.68373 4.48528 8.45587 4.48528Z"
                    fill="white"
                  />
                </svg>
              </a>
              <span className="hidden md:inline text-white mx-4">|</span>
              <a
                href="https://www.linkedin.com/company/talkdei/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667Z"
                    fill="white"
                  />
                  <path
                    d="M5.05664 3.66321C5.05664 4.10823 4.67088 4.46899 4.19507 4.46899C3.71923 4.46899 3.3335 4.10823 3.3335 3.66321C3.3335 3.21818 3.71923 2.85742 4.19507 2.85742C4.67088 2.85742 5.05664 3.21818 5.05664 3.66321Z"
                    fill="#1D2739"
                  />
                  <path
                    d="M3.45117 5.06152H4.92392V9.52433H3.45117V5.06152Z"
                    fill="#1D2739"
                  />
                  <path
                    d="M7.29503 5.06023H5.82227V9.52304H7.29503C7.29503 9.52304 7.29503 8.11808 7.29503 7.23966C7.29503 6.71237 7.47508 6.1828 8.19341 6.1828C9.00522 6.1828 9.00036 6.8728 8.99655 7.40737C8.9916 8.10608 9.00341 8.81918 9.00341 9.52304H10.4762V7.16766C10.4637 5.6637 10.0718 4.9707 8.7825 4.9707C8.01684 4.9707 7.54222 5.31832 7.29503 5.6328V5.06023Z"
                    fill="#1D2739"
                  />
                </svg>
              </a>
            </div>

            <div className="flex flex-col md:flex-row items-start space-y-2 md:space-y-0 md:space-x-6 text-base text-left ml-0 sm:ml-10">
              <span
                onClick={() => navigate("/legal-page/privacy-policy")}
                className="text-gray-400 hover:text-white transition-colors text-left cursor-pointer"
              >
                Privacy Policy
              </span>
              <span
                onClick={() => navigate("/legal-page/terms-of-use")}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Terms & Conditions
              </span>
              <span
                onClick={() => navigate("/legal-page/ccpa-policy")}
                className="text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                CCPA Policy
              </span>
            </div>
          </div>

          <p className="text-gray-400 text-sm mt-6 md:mt-0 md:ml-4 text-left">
            © {currentYear} SourceIQ LLC. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
